var map = {
	"./1.jpg": 3914,
	"./2.jpg": 5537,
	"./3.jpg": 3227,
	"./4.jpg": 2089,
	"./5.jpg": 5519,
	"./6.jpg": 1955,
	"./7.jpg": 939,
	"./8.jpg": 1056,
	"./9.jpg": 1883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4741;